
// Sources for the armpit health basics article
export const armpitHealthBasicsSources = [
  {
    text: "Journal of Applied Microbiology: 'The skin microbiome'",
    link: "https://sfamjournals.onlinelibrary.wiley.com/journal/13652672"
  },
  {
    text: "International Journal of Cosmetic Science: 'Understanding the armpit microbiome'",
    link: "https://onlinelibrary.wiley.com/journal/14682494"
  },
  {
    text: "American Academy of Dermatology: 'Hyperhidrosis'",
    link: "https://www.aad.org/public/diseases/a-z/hyperhidrosis-treatment"
  },
  {
    text: "Mayo Clinic: 'Sweating and body odor'",
    link: "https://www.mayoclinic.org/diseases-conditions/sweating-and-body-odor/symptoms-causes/syc-20353895"
  }
];
